<div class="toptext">
    <p>Le attività della De Cifris comprendono il finanziamento di borse per la crittografia,
        la gestione di riviste scientifiche e divulgative, l'organizzazione di altre iniziative
        divulgative ed eventi pubblici qualificanti, convegni annuali e numerosi cicli di seminari.
        <br>
        I nostri contenuti sono diffusi anche tramite le pagine
        <a href="https://www.youtube.com/channel/UCTgLUneI3agkv_FcW0RlI0A" target="_blank">YouTube</a> e
        <a href="https://www.linkedin.com/in/de-componendis-cifris-iniziativa-nazionale-8274501a5/"
            target="_blank">LinkedIn</a> dell'associazione.
    </p>
</div>
<div class="iniziativecontainer">
    <mat-card mat-button routerLink="/attivita/eventi" class="txtbtn">
        <mat-card-content class="txtbtn-txt">Eventi</mat-card-content>
    </mat-card>
    <mat-card mat-button routerLink="/attivita/corsi" class="txtbtn">
        <mat-card-content class="txtbtn-txt">Corsi</mat-card-content>
    </mat-card>
    <mat-card mat-button routerLink="/attivita/seminari" class="txtbtn">
        <mat-card-content class="txtbtn-txt">Seminari</mat-card-content>
    </mat-card>
    <mat-card mat-button routerLink="/attivita/editoria" class="txtbtn">
        <mat-card-content class="txtbtn-txt">Editoria</mat-card-content>
    </mat-card>
    <mat-card mat-button routerLink="/attivita/gare-crittografiche" class="txtbtn">
        <mat-card-content class="txtbtn-txt">Gare crittografiche</mat-card-content>
    </mat-card>
    <mat-card mat-button routerLink="/attivita/iniziative-divulgative" class="txtbtn">
        <mat-card-content class="txtbtn-txt">Iniziative divulgative</mat-card-content>
    </mat-card>
</div>